if(typeof BSS_B2B != undefined) {
  setTimeout(() => {
      const quickViews = document.querySelectorAll(".modal");
      quickViews.forEach((quickView) => {
        const mutationObserver = new MutationObserver((recordList, observe) => {
            BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, true);
        });
           mutationObserver.observe(quickView, { attributes: true });
      })
  }, 5000);
}

document.addEventListener('click', function(event) {
  const toggleBtn = event.target.closest('.bss-button-toggle-table');
  if (toggleBtn) {
    event.preventDefault();
    toggleBtn.parentNode.querySelector(".bss-b2b-up-down-qb-btn")?.click?.();
  }
});

document.addEventListener("bss.b2b.qb.doneCheckQB", e => {
  handleAddUnitText();
});

document.addEventListener("done_render_qb_table", e => {
  handleAddUnitText();
});

function handleAddUnitText() {
  document.querySelectorAll(".bss-b2b-qty-table-row td:first-child").forEach(item => {
    if(!item.innerText.includes("units")) {
        item.innerText += " units";
    }
  })
}